import type { DeviceConfiguration } from '../../../data/configuration/types';

import { DeviceConfigurationPersonalListEnums } from './types';

export function processPersonalListEnums(
  personalListEnums: DeviceConfigurationPersonalListEnums,
): NonNullable<DeviceConfiguration['personalLists']> {
  const { chosen_search_list, personal_list, saved_interest_items_list, user_personal_lineup } = personalListEnums;

  return {
    chosenSearch: chosen_search_list ? Number(chosen_search_list) : undefined,
    personal: personal_list ? Number(personal_list) : undefined,
    savedInterestItems: saved_interest_items_list ? Number(saved_interest_items_list) : undefined,
    userPersonalLineup: user_personal_lineup ? Number(user_personal_lineup) : undefined,
  };
}
